module.exports = __webpack_public_path__ + "img/fleet-plane.acb94d5.webp";